import LegalLayout from './components/LegalLayout';

const sections = [
  {
    title: '著作権の帰属',
    body: '当サイト「鳥取ではじめての家づくり」に掲載されている文章・画像・図解・デザインなど、すべてのコンテンツの著作権は当サイト運営者に帰属します。',
  },
  {
    title: '引用について',
    body: '当サイトのコンテンツを引用する場合は、以下のルールに従ってください。',
    items: [
      '引用元として当サイト名（鳥取ではじめての家づくり）を明記すること',
      '引用元ページへのリンクを設置すること',
      '引用の範囲は必要最小限にとどめ、改変は行わないこと',
    ],
  },
  {
    title: '無断転載・複製の禁止',
    body: '当サイトに掲載されているすべてのコンテンツについて、事前の許可なく転載・複製・再配布することを禁止します。\n商用利用・二次利用を希望される場合は、お問い合わせフォームよりご連絡ください。',
  },
  {
    title: 'お問い合わせ',
    body: '著作権に関するご質問・ご連絡は、当サイト内のお問い合わせフォームよりお送りください。',
  },
];

export default function CopyrightPage() {
  return (
    <LegalLayout
      title="著作権について"
      subtitle="鳥取ではじめての家づくり"
      lastUpdated="2026年3月"
      sections={sections}
    />
  );
}
